// 文本格式化工具

/**
 * 将纯文本转换为HTML格式
 * 处理换行符、段落分隔等
 */
export const formatTextToHtml = (text: string): string => {
  if (!text) return '';
  
  // 先标准化换行符（处理不同操作系统的换行符差异）
  // Windows: \r\n, Mac/Unix: \n, 旧版Mac: \r
  const normalizedText = text.replace(/\r\n|\r/g, '\n').trim();
  
  // 调试输出
  console.log('原始文本长度:', text.length);
  console.log('标准化后文本长度:', normalizedText.length);
  console.log('包含换行符数量:', (normalizedText.match(/\n/g) || []).length);
  
  // 将连续的换行符（空行）视为段落分隔
  // 匹配一个或多个换行符，可能中间有空白字符
  const paragraphs = normalizedText.split(/\n[\s]*\n+/);
  
  console.log('分割后段落数量:', paragraphs.length);
  
  // 将每个段落包装在<p>标签中，并处理段落内的单个换行符
  const htmlParagraphs = paragraphs
    .filter(paragraph => paragraph.trim()) // 过滤空段落
    .map(paragraph => {
      // 将段落内的单个换行符转换为<br>标签
      const formattedParagraph = paragraph
        .trim()
        .replace(/\n/g, '<br>');
      
      return `<p>${formattedParagraph}</p>`;
    });
  
  console.log('最终HTML段落数量:', htmlParagraphs.length);
  
  return htmlParagraphs.join('\n');
};

/**
 * 检测文本是否已经是HTML格式
 */
export const isHtmlContent = (text: string): boolean => {
  if (!text) return false;
  
  // 更精确地检测是否包含HTML标签
  // 检查常见的HTML标签，如<p>, <div>, <span>, <br>, <h1>-<h6>等
  const commonHtmlTags = /<(p|div|span|br|h[1-6]|ul|ol|li|table|tr|td|th|img|a|strong|em|b|i)\b[^>]*>|<\/(p|div|span|h[1-6]|ul|ol|li|table|tr|td|th|a|strong|em|b|i)>/i;
  
  // 如果文本中包含大量<br>标签但没有其他HTML标签，我们也认为它不是HTML格式
  // 因为这可能是从其他地方复制的文本，其中换行被自动转换为<br>
  if (text.includes('<br>') && !text.match(/<(?!br\b)[a-z]/i)) {
    return false;
  }
  
  return commonHtmlTags.test(text);
};

/**
 * 智能格式化文本
 * 如果已经是HTML则直接返回，否则转换为HTML
 */
export const smartFormatText = (text: string): string => {
  if (!text) return '';
  
  console.log('格式化前文本长度:', text.length);
  console.log('文本前30个字符:', text.substring(0, 30));
  console.log('是否检测为HTML:', isHtmlContent(text));
  
  // 如果文本已经是HTML格式，直接返回
  if (isHtmlContent(text)) {
    console.log('检测为HTML内容，保持原格式');
    return text;
  }
  
  // 否则将纯文本转换为HTML格式
  console.log('检测为纯文本，进行格式化');
  const formattedText = formatTextToHtml(text);
  console.log('格式化后HTML长度:', formattedText.length);
  
  return formattedText;
};